import React from 'react'
import { NavLink } from 'react-router-dom'

function BreadCrums({
    title, data, showButton
}) {
    return (
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
                <h2 className="mb-1">{title || "Dashboard"}</h2>
                <nav>
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                            <a href="#"><i className="ti ti-smart-home"></i></a>
                        </li>
                        {
                            data?.map((item, index) => {
                                return (
                                    <li key={index} className="breadcrumb-item">
                                        <NavLink to={item?.path}>
                                            {item?.title || "test"}
                                        </NavLink>
                                    </li>
                                )
                            })
                        }
                    </ol>
                </nav>
            </div>
            {/* show this conditionaly */}
            {
                showButton &&
                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                    <div className="input-icon mb-2 position-relative">
                        <button className='btn btn-primary ' onClick={showButton}>
                            <span className=" pr-1">
                                <i className="ti ti-download text-white"></i>
                            </span>
                            Download
                        </button>
                    </div>
                </div>
            }
        </div>
    )
}

export default BreadCrums
